import axios from "../axios-auth";
import orginal_axios from "axios";

export const productGroupService = {
  getProductGroupList,
  saveProductGroup,
  getProductGroupDetail,
  getProductGroupsByStatus,
  getAllProductGroup,
  saveProductGroupExcel,
  getProductGroupExcelTemplate,
  getProductGroupExcelExport
};

function getProductGroupList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.code) {
    params["code"] = searchParams.code;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  return axios.get("/auth/product-groups", { params });
}

function saveProductGroup(productGroup) {
  if (!productGroup.id) {
    // new productGroup
    return axios.post("/auth/product-group", productGroup);
  } else {
    // edit
    return axios.put("/auth/product-group", productGroup);
  }
}

function getProductGroupDetail(id) {
  return axios.get("/auth/product-group/" + id);
}

function getProductGroupsByStatus(status) {
  return axios.get("/auth/product-groups-by-status/" + status);
}

function getAllProductGroup() {
  return axios.get("/auth/all-product-group");
}

function saveProductGroupExcel(file) {
  return axios.post('/auth/product-group-excel',
    file,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
}

function getProductGroupExcelTemplate() {
  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/product-group-excel-template",
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}

function getProductGroupExcelExport(searchParams) {
  let params = {};

  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.code) {
    params["code"] = searchParams.code;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }

  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/product-group-excel",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}
